import { type ShareRow, formatPersonName } from '#shared/types';

/** "Ayesha Khan", or "Automatic — Ayesha Khan" for a send the last release caused. */
export function sentBy(row: ShareRow): string {
  const person = formatPersonName(row.shared_by);
  return row.trigger === 'auto' ? `Automatic — ${person}` : person;
}
